export const classes = {
  link: 'text-blue-3 underline hover:text-blue-4 transition-colors break-words',
};
